
import config from "config";
import { APICore } from "helpers/api/apiCore";
import { unmaskPiiFieldByUrl } from "helpers/piiUnmask";
import { FilterMetadata } from "redux/types";

const api = new APICore();


function fetchInstrumentApi(params: any) {
    // console.log('params');
    // console.log('decodeURI(params)',decodeURI(params));
    
    
    const baseUrl = `${config.BACKEND_TXN_BASE_URL}/instruments/${decodeURI(params)}`;
    return api.get(`${baseUrl}`, params);
}

function fetchAllInstrumentsApi(params: any) {
    const baseUrl = `${config.BACKEND_TXN_BASE_URL}/instruments`;
    return api.get(`${baseUrl}`, params);
}

function unmaskInstrumentPiiFieldApi(recordId: string, fieldName: string) {
  return unmaskPiiFieldByUrl(`${config.BACKEND_TXN_BASE_URL}/instruments/${recordId}/pii/unmask`, fieldName);
}

export { fetchInstrumentApi, fetchAllInstrumentsApi, unmaskInstrumentPiiFieldApi }